import { V1Practical } from "src/pages/reports/ffi/v1/types";

export const meta: Record<V1Practical, Opportunity> = {
    guardingTheMission: {
        title: "Guarding The Mission",
        prologue: "Board members feel confident that the school will guard its mission (1 Timothy 6:20).",
    },
    missionalHiring: {
        title: "Missional Hiring",
        prologue:
            "The school hires faculty and staff who are rooted in their faith and support the school’s beliefs and mission (Amos 3:3; 2 Corinthians 6:14).",
    },
    specialEducationInclusion: {
        title: "Special Education Inclusion",
        prologue:
            "The school’s special education practices welcome students with special needs and honor them as image bearers (Psalm 139:13-16; Mark 10:14; John 9:1-3).",
    },
    biblicalPerspectives: {
        title: "Biblical Perspectives",
        prologue:
            "From the perspective of alumni, the school provided students opportunities to engage with biblical perspectives on social and political issues (Romans 12:2; Ephesians 2:1-2; Colossians 2:8).",
    },
    equippingForGoodWork: {
        title: "Equipping For Good Work",
        prologue:
            "Administrators and staff believe the school provides students with practical skills for evaluating the world and stewarding their health and financial resources (Proverbs 22:6; Luke 6:40; 1 Timothy 4:8; 2 Timothy 3:16).",
    },
    sabbathKeeping: {
        title: "Sabbath Keeping",
        prologue:
            "The school has policies to help personnel and families keep the Sabbath and communicates these expectations (Exodus 20:8-11; Deuteronomy 5:12-15; Hebrews 4:1-13).",
    },
    familyDevotions: {
        title: "Family Devotions",
        prologue:
            "Parents and students report spending time in their families reading and praying together (Deuteronomy 6:7; Joshua 24:15; Psalms 78, 127).",
    },
    parentalProtection: {
        title: "Parental Protection",
        prologue:
            "Parents provide a healthy “hedge of protection” for their children from potentially harmful content (Job 1:10).",
    },
};
